import { NgModule } from '@angular/core';
import { UserProfilePage } from 'pages/user-profile/user-profile';
import { CsSubscriptionCard } from 'pages/user-profile/cs-subscription-card';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    // the subscription card is declared here rather than in ComponentsModule:
    // only this page uses it, and its styles live in this page's stylesheet
    declarations: [UserProfilePage, CsSubscriptionCard],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class UserProfilePageModule {}
